"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localeMap = {
    'bg-BG': 1026,
    'cs-CZ': 1029,
    'da-DK': 1030,
    'de-DE': 1031,
    'el-GR': 1032,
    'en-US': 1033,
    'es-ES': 3082,
    'fi-FI': 1035,
    'fr-CA': 3084,
    'fr-FR': 1036,
    'hu-HU': 1038,
    'it-IT': 1040,
    'ja-JP': 1041,
    'ko-KR': 1042,
    'nb-NO': 1044,
    'nl-NL': 1043,
    'pl-PL': 1045,
    'pt-BR': 1046,
    'pt-PT': 2070,
    'ro-RO': 1048,
    'ru-RU': 1049,
    'hr-HR': 1050,
    'sk-SK': 1051,
    'sv-SE': 1053,
    'th-TH': 1054,
    'tr-TR': 1055,
    'uk-UA': 1058,
    'sl-SI': 1060,
    'vi-VN': 1066,
    'zh-Hant': 31748,
    'zh-Hans': 2052,
    'zh-CHT': 31748,
    'zh-CN': 2052,
    'sr-RS': 2074
};
/**
 *  This utility would return null if locale is null or key is not present in localeMap
 *  otherwise return the localeId.
 * @param locale
 */
var getLocaleId = function (locale) {
    if (!locale || !localeMap[locale]) {
        return null;
    }
    return localeMap[locale];
};
exports.default = getLocaleId;
